import { Box } from '@mui/material';
import { ButtonUI, DialogUI, InputUI } from '../Interface';
import { sxConfig } from './joker.style';
import { useEffect, useState } from 'react';

const JokerGroupDialog = ({ dialogData, handleClose, onSave }) => {
  const { open, id, groupName } = dialogData;
  const [name, setName] = useState('');

  useEffect(() => {
    if (open) {
      setName(groupName || '');
    }
  }, [open]);

  return (
    <DialogUI
      open={open}
      headerContent={id ? 'Csoport módosítása' : 'Csoport létrehozása'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      maxWidth="sm"
    >
      <Box sx={sxConfig.dialogContainer}>
        <InputUI placeholder="Csoport megnevezése" autoFocus onChange={(e) => setName(e.target.value)} value={name} />
        <Box sx={sxConfig.dialogSaveBtn}>
          <ButtonUI
            text="Mentés"
            className="bg-success"
            disabled={name.trim().length === 0}
            onClick={() => onSave(name)}
          />
        </Box>
      </Box>
    </DialogUI>
  );
};

export default JokerGroupDialog;
